import PatientServices from './PatientServices';

export default PatientServices;

